import { ProductListingLayout } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";

export enum ProductLinesSortOptions {
  Relevance = "relevance",
  BestSellers = "best-seller",
  PriceAsc = "price-asc",
  PriceDesc = "price-desc",
  NewlyAdded = "newly-added",
  NameAsc = "name-asc",
  NameDesc = "name-desc",
}

export const sortingRequiresLessAds = (sortOption: ProductLinesSortOptions) => {
  return [
    ProductLinesSortOptions.NewlyAdded,
    ProductLinesSortOptions.PriceAsc,
    ProductLinesSortOptions.PriceDesc,
  ].includes(sortOption);
};

export const adCountForSortingAndLayout = (
  sortOption: ProductLinesSortOptions,
  layout: ProductListingLayout
) => {
  return layout === ProductListingLayout.List && sortingRequiresLessAds(sortOption) ? 2 : 6;
};
